module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetHigh@2x.83f706a.jpg";